import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { COMPONENTS } from '../../../../routers/constants'
import {
  applyCriteria,
  selectSelectedIndicatorCount,
} from '../../selectCriteria/store/slice'
import { selectSelectedCriteria } from '../store/slice'
import classes from './index.module.scss'

export const ApplyCriteria = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)
  const selectedCriteria = useSelector(selectSelectedCriteria())

  const [isShow, setIsShow] = useState(false)

  const handleOpen = () => {
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const handleApplyCriteria = () => {
    dispatch(applyCriteria(selectedCriteria))
    navigate(COMPONENTS.screening.route)
  }

  const onClickApply = () => {
    if (selectedIndicatorCount) {
      handleOpen()
    } else {
      handleApplyCriteria()
    }
  }

  return (
    <>
      <Button
        label="screening.APPLY"
        isI18n
        action={onClickApply}
        className={classes.applyBtn}
        style={{ color: '#FFFFFF', backgroundColor: '#2C73E8' }}
      />
      <PopupAction
        isShow={isShow}
        title="screening.APPLY_CRITERIA"
        btnCancel={{
          label: 'screening.CANCEL',
          isI18n: true,
          event: handleClose,
        }}
        btnSubmit={{
          label: 'screening.APPLY',
          isI18n: true,
          event: handleApplyCriteria,
        }}
        handleClose={handleClose}
      >
        <Element className="textCenter pb1">
          <Element className="breakWord" style={{ color: '#3A414B' }}>
            <Translate
              value="screening.APPLY_CRITERIA_MESS"
              name={selectedCriteria.screeningSavedCriteriaName}
              dangerousHTML
            />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
